"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isFuroChainId = exports.FURO_VESTING_ROUTER_ADDRESS = exports.FURO_VESTING_ADDRESS = exports.FURO_STREAM_ROUTER_ADDRESS = exports.FURO_STREAM_ADDRESS = exports.FURO_SUPPORTED_CHAIN_IDS = void 0;
const chain_1 = require("@sushiswap/chain");
exports.FURO_SUPPORTED_CHAIN_IDS = [
    chain_1.ChainId.ARBITRUM,
    chain_1.ChainId.AVALANCHE,
    chain_1.ChainId.BSC,
    chain_1.ChainId.BTTC,
    chain_1.ChainId.ETHEREUM,
    chain_1.ChainId.FANTOM,
    chain_1.ChainId.GNOSIS,
    // ChainId.HARMONY,
    chain_1.ChainId.MOONBEAM,
    chain_1.ChainId.MOONRIVER,
    chain_1.ChainId.OPTIMISM,
    chain_1.ChainId.POLYGON,
    chain_1.ChainId.HAQQ,
    chain_1.ChainId.CORE,
    chain_1.ChainId.THUNDERCORE
];
exports.FURO_STREAM_ADDRESS = {
    [chain_1.ChainId.ARBITRUM]: '0x4ab2FC6e258a0cA7175D05fF10C5cF798A672cAE',
    [chain_1.ChainId.AVALANCHE]: '0x4ab2FC6e258a0cA7175D05fF10C5cF798A672cAE',
    [chain_1.ChainId.BSC]: '0x4ab2FC6e258a0cA7175D05fF10C5cF798A672cAE',
    [chain_1.ChainId.BTTC]: '0x3DB923FBaB372ab8c796Fef9bb8341CdB37cB9eC',
    [chain_1.ChainId.ETHEREUM]: '0x4ab2FC6e258a0cA7175D05fF10C5cF798A672cAE',
    [chain_1.ChainId.FANTOM]: '0x4ab2FC6e258a0cA7175D05fF10C5cF798A672cAE',
    [chain_1.ChainId.GNOSIS]: '0x4ab2FC6e258a0cA7175D05fF10C5cF798A672cAE',
    // [ChainId.HARMONY]: '',
    [chain_1.ChainId.MOONBEAM]: '0x4ab2FC6e258a0cA7175D05fF10C5cF798A672cAE',
    [chain_1.ChainId.MOONRIVER]: '0x4ab2FC6e258a0cA7175D05fF10C5cF798A672cAE',
    [chain_1.ChainId.OPTIMISM]: '0x4ab2FC6e258a0cA7175D05fF10C5cF798A672cAE',
    [chain_1.ChainId.POLYGON]: '0x4ab2FC6e258a0cA7175D05fF10C5cF798A672cAE',
    [chain_1.ChainId.HAQQ]: '0x57bfFa72db682f7eb6C132DAE03FF36bBEB0c459',
    [chain_1.ChainId.CORE]: '0x33d91116e0370970444b0281ab117e161febfcdd',
    [chain_1.ChainId.THUNDERCORE]: '0x1400feFD6F9b897970f00Df6237Ff2B8b27Dc82C'
};
exports.FURO_STREAM_ROUTER_ADDRESS = {
    [chain_1.ChainId.ARBITRUM]: '0xf30CF8D373D78D7964A2F7793b730BF7ae0970a8',
    [chain_1.ChainId.AVALANCHE]: '0x4947754676098B1D06dE1C602D0086e406154e89',
    [chain_1.ChainId.BSC]: '0xf30CF8D373D78D7964A2F7793b730BF7ae0970a8',
    [chain_1.ChainId.BTTC]: '0xc5017BE80b4446988e8686168396289a9A62668E',
    [chain_1.ChainId.ETHEREUM]: '0x95bd909A9cB3002992E2993846b035545F15ff37',
    [chain_1.ChainId.FANTOM]: '0xf30CF8D373D78D7964A2F7793b730BF7ae0970a8',
    [chain_1.ChainId.GNOSIS]: '0xf30CF8D373D78D7964A2F7793b730BF7ae0970a8',
    // [ChainId.HARMONY]: '',
    [chain_1.ChainId.MOONBEAM]: '0xf30CF8D373D78D7964A2F7793b730BF7ae0970a8',
    [chain_1.ChainId.MOONRIVER]: '0xf30CF8D373D78D7964A2F7793b730BF7ae0970a8',
    [chain_1.ChainId.OPTIMISM]: '0xf30CF8D373D78D7964A2F7793b730BF7ae0970a8',
    [chain_1.ChainId.POLYGON]: '0xf30CF8D373D78D7964A2F7793b730BF7ae0970a8',
    [chain_1.ChainId.HAQQ]: '0xe43ca1Dee3F0fc1e2df73A0745674545F11A59F5',
    [chain_1.ChainId.CORE]: '0xb46e319390De313B8cc95EA5aa30C7bBFD79Da94',
    [chain_1.ChainId.THUNDERCORE]: '0xb46e319390De313B8cc95EA5aa30C7bBFD79Da94'
};
exports.FURO_VESTING_ADDRESS = {
    [chain_1.ChainId.ARBITRUM]: '0x0689640d190b10765f09310fCfE9C670eDe4E25B',
    [chain_1.ChainId.AVALANCHE]: '0x0689640d190b10765f09310fCfE9C670eDe4E25B',
    [chain_1.ChainId.BSC]: '0x0689640d190b10765f09310fCfE9C670eDe4E25B',
    [chain_1.ChainId.BTTC]: '0x5629CE74DdCAD7Cc72b3Ea30444dA7172AD851D9',
    [chain_1.ChainId.ETHEREUM]: '0x0689640d190b10765f09310fCfE9C670eDe4E25B',
    [chain_1.ChainId.FANTOM]: '0x0689640d190b10765f09310fCfE9C670eDe4E25B',
    [chain_1.ChainId.GNOSIS]: '0x0689640d190b10765f09310fCfE9C670eDe4E25B',
    // [ChainId.HARMONY]: '',
    [chain_1.ChainId.MOONBEAM]: '0x0689640d190b10765f09310fCfE9C670eDe4E25B',
    [chain_1.ChainId.MOONRIVER]: '0x0689640d190b10765f09310fCfE9C670eDe4E25B',
    [chain_1.ChainId.OPTIMISM]: '0x0689640d190b10765f09310fCfE9C670eDe4E25B',
    [chain_1.ChainId.POLYGON]: '0x0689640d190b10765f09310fCfE9C670eDe4E25B',
    [chain_1.ChainId.HAQQ]: '0x1400feFD6F9b897970f00Df6237Ff2B8b27Dc82C',
    [chain_1.ChainId.CORE]: '0xBda8a8423B7F02Cd935412FB9F13CB88f7875991',
    [chain_1.ChainId.THUNDERCORE]: '0xBda8a8423B7F02Cd935412FB9F13CB88f7875991'
};
exports.FURO_VESTING_ROUTER_ADDRESS = {
    [chain_1.ChainId.ARBITRUM]: '0x312A8E33d78d3Ab79E62971E86e5e8c9c5E28D64',
    [chain_1.ChainId.AVALANCHE]: '0x134C28E1aA0b5F339e498951bAEA9165c4Dbea90',
    [chain_1.ChainId.BSC]: '0x312A8E33d78d3Ab79E62971E86e5e8c9c5E28D64',
    [chain_1.ChainId.BTTC]: '0xBD87Bef520f8CEC45d73B0413B6cBb8b061736d9',
    [chain_1.ChainId.ETHEREUM]: '0x8E190A2173334c67734119791CF63299A7570877',
    [chain_1.ChainId.FANTOM]: '0x312A8E33d78d3Ab79E62971E86e5e8c9c5E28D64',
    [chain_1.ChainId.GNOSIS]: '0x312A8E33d78d3Ab79E62971E86e5e8c9c5E28D64',
    // [ChainId.HARMONY]: '',
    [chain_1.ChainId.MOONBEAM]: '0x312A8E33d78d3Ab79E62971E86e5e8c9c5E28D64',
    [chain_1.ChainId.MOONRIVER]: '0x312A8E33d78d3Ab79E62971E86e5e8c9c5E28D64',
    [chain_1.ChainId.OPTIMISM]: '0x312A8E33d78d3Ab79E62971E86e5e8c9c5E28D64',
    [chain_1.ChainId.POLYGON]: '0x312A8E33d78d3Ab79E62971E86e5e8c9c5E28D64',
    [chain_1.ChainId.HAQQ]: '0x1f2FCf1d036b375b384012e61D3AA33F8C256bbE',
    [chain_1.ChainId.CORE]: '0x544bA588efD839d2692Fc31EA991cD39993c135F',
    [chain_1.ChainId.THUNDERCORE]: '0x039e87AB90205F9d87c5b40d4B28e2Be45dA4a20'
};
const isFuroChainId = (chainId) => exports.FURO_SUPPORTED_CHAIN_IDS.includes(chainId);
exports.isFuroChainId = isFuroChainId;
//# sourceMappingURL=index.js.map